export const NESTED_HOVER_EVENT = 'mpz-dnd-nested-hover'
export const NESTED_UNHOVER_EVENT = 'mpz-dnd-nested-unhover'

export function notifyAncestorsNestedHover(element) {
    const parent = element?.parentElement
    if (parent) {
        parent.dispatchEvent(new CustomEvent(NESTED_HOVER_EVENT, { bubbles: true }))
    }
}

export function notifyAncestorsNestedUnhover(element) {
    const parent = element?.parentElement
    if (parent) {
        parent.dispatchEvent(new CustomEvent(NESTED_UNHOVER_EVENT, { bubbles: true }))
    }
}
